import Button from "devextreme-react/button";
import { useContext } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AR, OrderStatus } from "../../../../types/enums";
import { RetailOrderContext } from "../context/RetailOrderContext";

export default function NewMaterialOrderButton() {

	const navigate = useNavigate();
	const [params] = useSearchParams();
	const returnUrl = encodeURIComponent(params.get("returnUrl") ?? "");

	const { order } = useContext(RetailOrderContext);

	return (
		<Button
			elementAttr={{ 'data-testid': 'btn-new-material-order' }}
			text="New Material Order"
			icon="Inscyth-Add"
			visible={(order.details.orderStatusID === OrderStatus.Open || order.details.orderStatusID === OrderStatus.Hold) &&
				!order.details.resolvedARs.includes(AR.CfiToEnterActualInstallDate)}
			onClick={() => {
				navigate(`/cfi/retail-order/${order.details.retailOrderID}/130/new` +
					(!!returnUrl ? '?returnUrl=' + returnUrl : ''));
			}} >
		</Button>
	)
}
